import {
    REQUEST_WORK_MODAL_CREATE,
    REQUEST_WORK_MODAL_QUERY_KEY,
} from '@features/AddRequestMaterial/model/consts';
import { useNuqsQueryState } from '@shared/hooks';

export const useAddRequestMaterial = () => {
    const { state, setState, clearQueryValue } = useNuqsQueryState(REQUEST_WORK_MODAL_QUERY_KEY);

    const isCreateModalOpen = state === REQUEST_WORK_MODAL_CREATE;

    const onOpenAddModal = () => setState(REQUEST_WORK_MODAL_CREATE);
    const onCloseAddModal = () => clearQueryValue();

    return {
        isCreateModalOpen,
        onOpenAddModal,
        onCloseAddModal,
    };
};
